const applyParameter = (route, parameterName, parameterValue) => route.replace(`{${parameterName}}`, parameterValue);

export const applyParameters = (route, parameters) => {
    const parametersPlaceholders = route.match(/[^{}]+(?=})/g);

    if (parametersPlaceholders) {
        let newRoute = route;

        parametersPlaceholders.forEach((parameter) => {
            const parameterValue = parameters[parameter];

            if (parameterValue) {
                newRoute = applyParameter(newRoute, parameter, parameterValue);
            }
        });

        return newRoute;
    }

    return route;
};
